import { Component } from '@angular/core';

@Component({
    selector: 'carm-card-content',
    template: '<ng-content></ng-content>',
})
export class CardContentComponent {}
